export const EMPLOYEE_RANGE_VALUES = [
  'Less than 10',
  '10 - 49',
  '50 - 199',
  '200 - 499',
  '500 - 999',
  '1,000 - 4,999',
  '5,000 - 9,999',
  'Above 10,000',
] as const;

export const REVENUE_RANGE_VALUES = [
  'Less than 1M',
  '1M - 2M',
  '2M - 5M',
  '5M - 10M',
  '10M - 50M',
  '50M - 100M',
  '100M - 500M',
  '500M - 1B',
  'More than 1B',
] as const;

const EMPLOYEE_RANGE_ALIASES: Record<string, string[]> = {
  'Micro (1-20 Employees)': ['Less than 10', '10 - 49'],
  'Small (21-100 Employees)': ['10 - 49', '50 - 199'],
  'Medium (101-500 Employees)': ['50 - 199', '200 - 499', '500 - 999'],
  'Medium-Large (501-1000 Employees)': ['500 - 999', '1,000 - 4,999'],
  'Large (1001-5000 Employees)': ['1,000 - 4,999', '5,000 - 9,999'],
  'XLarge (5001+ Employees)': ['5,000 - 9,999', 'Above 10,000'],
  'Over 10000': ['Above 10,000'],
};

const REVENUE_RANGE_ALIASES: Record<string, string[]> = {
  'Less than $1 Million': ['Less than 1M'],
  '$1 - 9.99 Million': ['1M - 2M', '2M - 5M', '5M - 10M'],
  '$1 Million - $10 Million': ['1M - 2M', '2M - 5M', '5M - 10M'],
  '$10 - 49.99 Million': ['10M - 50M'],
  '$50 - 99.99 Million': ['50M - 100M'],
  '$50-100MM': ['50M - 100M'],
  '$100 - 999.99 Million': ['100M - 500M', '500M - 1B'],
  '$100-200MM': ['100M - 500M'],
  '$500MM-1B': ['500M - 1B'],
  '$1+ Billion': ['More than 1B'],
  'Over $1B': ['More than 1B'],
};

function unique(values: string[]): string[] {
  return values.filter((value, index) => values.indexOf(value) === index);
}

export function expandEmployeeRange(value?: string | null): string[] {
  if (!value) {
    return [];
  }

  return EMPLOYEE_RANGE_ALIASES[value] ?? [value];
}

export function expandRevenueRange(value?: string | null): string[] {
  if (!value) {
    return [];
  }

  return REVENUE_RANGE_ALIASES[value] ?? [value];
}

export function getRangeOrder(searchField: string): readonly string[] | null {
  if (searchField === 'employeeRange') {
    return EMPLOYEE_RANGE_VALUES;
  }

  if (searchField === 'revenueRange') {
    return REVENUE_RANGE_VALUES;
  }

  return null;
}

export function normalizeRangeValue(
  searchField: string,
  value?: string | null
): string | undefined {
  if (searchField === 'employeeRange') {
    return expandEmployeeRange(value)[0];
  }

  if (searchField === 'revenueRange') {
    return expandRevenueRange(value)[0];
  }

  return value ?? undefined;
}

export function expandRangeValues(searchField: string, values: string[] = []): string[] {
  const expandedValues = values.flatMap((value) => {
    if (searchField === 'employeeRange') {
      return expandEmployeeRange(value);
    }

    if (searchField === 'revenueRange') {
      return expandRevenueRange(value);
    }

    return [value];
  });

  return unique(expandedValues);
}
